module.exports = __webpack_public_path__ + "img/upper_pocket_width_welt.f1e941fe.png";